(function ($) {
    'use strict';
    $(document).ready(function () {
        $("div[data-form-collection='list']").bind("DOMSubtreeModified", function () {
            activateRadios(".ui.radio:not(.modified)");
        });

        function activateRadios(selector) {
            $(selector).first().addClass('modified').checkbox();
        }
    });
})(jQuery);
